//Don't change fields inside internally used types.
//Lives in its own module so field formatters can import it without pulling
//in field-formatter.jsx — that import created a circular dependency
//(field-formatter → formatters → field-formatter) which crashes with a TDZ
//ReferenceError depending on which module the bundler evaluates first.
export const isInternalType = (Type) =>
    Type && ["ContentType", "FieldType", "Group", "Editor"].includes(Type.type)
